import { Component, EventEmitter, Output, inject } from '@angular/core';
import { LocalCsvService } from '../../../../../../../services/local-csv/local-csv.service';
import { StatusComponent } from '../../../../../../ui/status/status.component';
import { ToastService } from '../../../../../../../services/toast/toast.service';
import { formatCount } from '../../../../../../../../utils/sms';
import { COUNTRIES } from '../../../../../../../types/ussd.models';

type TReviewTab = 'duplicated' | 'removed' | 'updated' | 'invalids';

/**
 * Send readiness for the uploaded file: how many numbers will be added, what
 * will be skipped and why, and a way to take the invalid rows back to a
 * spreadsheet.
 */
@Component({
  selector: 'csv-phone-overview',
  standalone: true,
  imports: [StatusComponent],
  templateUrl: './overview.component.html',
  styleUrl: './overview.component.css',
})
export class OverviewComponent {
  constructor() {}
  localCSVService = inject(LocalCsvService);
  private toast = inject(ToastService);

  /** Ask the review step to open one of its tabs. */
  @Output() showTab = new EventEmitter<TReviewTab>();

  formatCount = formatCount;

  get ready(): number {
    return this.localCSVService.getSubmittableData.length;
  }

  get invalid(): number {
    return this.localCSVService.getInvalids.length;
  }

  get repeatedNumbers(): number {
    return this.localCSVService.getDuplicates.length;
  }

  get repeatedRows(): number {
    return this.localCSVService.getRepeatedRowCount;
  }

  get removed(): number {
    return this.localCSVService.getRemoved.length;
  }

  get edited(): number {
    return this.localCSVService.getUpdated.length;
  }

  get countryLabel(): string {
    const code = this.localCSVService.getDefaultCountry;
    if (!code) return 'International format only';
    const country = COUNTRIES.find((c) => c.code === code);
    return country ? `${country.name} (${country.dialCode}) when there is no country code` : code;
  }

  downloadInvalids(): void {
    const count = this.localCSVService.downloadInvalids();
    if (count) {
      this.toast.success(
        count === 1
          ? 'Downloaded 1 invalid number. Fix it, then upload the file again.'
          : `Downloaded ${formatCount(count)} invalid numbers. Fix them, then upload the file again.`
      );
    }
  }
}
